<template>
    <div style="width: 1100px; margin: 0 auto; border: 1px solid #cccccc;padding: 10px;">



        <div data-v-1b3be774="" class="col-12 pb-0 mb-0">
            <p data-v-1b3be774="" class="mb-1"> En este apartado debe detallar la información cuantitativa de acuerdo con
                las desagregaciones y fuentes de información registradas en la ficha técnica del indicador y su naturaleza.
            </p>
            <p data-v-1b3be774="" class="mb-1">
            <ul data-v-1b3be774="" class="pl-4 m-0 main">
                <li data-v-1b3be774="">Diligencie las celdas correspondientes con números enteros sin formato.</li>
                <li data-v-1b3be774="">No incluya letras ni símbolos.</li>
                <li data-v-1b3be774="">Si es necesario, use hasta dos decimales y separador de coma.</li>
                <li data-v-1b3be774="">Para tasas, no aproxime los valores.</li>
            </ul>
            </p>
            <p data-v-1b3be774="" class="m-0">Descargue la plantilla de reporte de desagregaciones haciendo clic <a
                    data-v-1b3be774="" href="/file/formato-desagregacion-siipo.xlsx" title="Descargar plantilla..."
                    target="_blank" class="font-weight-semibold">AQUÍ
                    <v-icon class="mr-2" >mdi-file-excel</v-icon>
                </a></p>
        </div>
        

        <div  style="margin-bottom: 20px;margin-left: 20px;">
            <label v-if="!deshabilitado"  style="font-weight: bold;">Subir plantilla de reporte de desagregaciones:</label>            
            <div v-if="!deshabilitado" style="margin-top: 20px;" class="pb-2 col content d-flex justify-content-between">
                <button style="padding-left: 0px !important;padding-right: 0px !important;"
                    class="btn btn-main" :loading="isSelecting" @click="handleFileImport">
                    <v-icon left>attach_file</v-icon>
                    Seleccione el archivo haciendo clic aquí
                </button>
                <input ref="uploadFileRef" id="uploadFileRef" class="d-none" type="file"
                    accept="application/pdf, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    @change="onFileChanged">
            </div>
            <div style="width: 98%;text-align: -webkit-right;" v-if="estadoCarga === true" >
                <button @click="descargarArchivo" style="display: flex; align-items: center;">
                    Descargar ultimo archivo exitoso
                    <v-icon class="mr-2" >mdi-file-excel</v-icon>
                </button>
            </div>
        </div>
        <v-snackbar v-model="snack" :timeout="timeoutsnak" :color="this.MesaggeInfo.color">
            {{ this.MesaggeInfo.codigoRespuesta }}
            {{ this.MesaggeInfo.mensajeRespuesta }}
            <div v-html="this.MesaggeInfo.descripcionHtml"></div>
            <v-btn text @click="functionalert">{{ buttontext }}</v-btn>
        </v-snackbar>
        <v-progress-linear :active="loading" indeterminate></v-progress-linear>

    </div>
</template>

<script>

import axios from 'axios';
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import store from "../../stores/index.js";
import moment from "moment";
import historico from "../../components/content/historico";
//import detalleindicador from "../../components/content/detalleindicador.vue";
import { ErrorBag } from 'vee-validate';
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import { quillEditor } from 'vue-quill-editor';
import Counter from "../../components/global/counter.js";
import Quill from 'quill';
import { number } from '@amcharts/amcharts4/core';


export default {
    name: 'Desagregacion',
    props: {
        idindicador: {
            type: Number,
            required: true
        },
        idtipovalor: {
            type: Number,
            required: true
        },
        rangoperiodo: {
            type: String,
            required: true
        },
        deshabilitado: {
            type: Boolean,
            default: false
        },
        estadoCarga: {
            type: Boolean,
            default: false
        },
        codigoIndicador: {
            type: String,
            required: ""
        },
        nombreIndicador: {
            type: String,
            required: ""
        },
        idavancecualitativo: {
            type: Number,
            required: true
        },
        idavctp: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            loading: false,
            file: null,
            idIndicadorNumber: 1,
            idTipoValorNumber: 1,
            idavancecualitativonumber: 0,
            idavancecualitativotipovalornumber: 0,
            isSelecting: false,
            //campos del cuadro de dialog de mensajes
            snack: false,
            MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "", descripcionHtml: "" }],
            timeoutsnak: 6000,
            buttontext: "cerrar",
        }
    },
    watch: {
        idindicador(newVal) {
            this.idIndicadorNumber = Number(newVal);
            //alert(`idindicador: ${newVal}`);
        },
        idtipovalor(newVal) {
            this.idTipoValorNumber = Number(newVal);
            //alert(`idtipovalor: ${newVal}`);
        },
        rangoperiodo(newVal) {
            this.rangoPeriodoString = this.rangoperiodo;
            //alert(`rango Periodo: ${newVal}`);
        },
        idavancecualitativo(newVal) {
            this.idavancecualitativonumber = this.idavancecualitativo;
            //alert(`rango Periodo: ${newVal}`);
        },
        idavctp(newVal) {
            this.idavancecualitativotipovalornumber = this.idavctp;
            console.log('idavancecualitativotipovalornumber', newVal)
        }

    },
    created() {
        this.idIndicadorNumber = Number(this.idindicador);
        this.idTipoValorNumber = Number(this.idtipovalor);
        this.rangoPeriodoString = this.rangoperiodo;
        this.idavancecualitativonumber = this.idavancecualitativo;
        this.idavancecualitativotipovalornumber = this.idavctp;
    },
    methods: {
        onFileChange() {
            //console.log('Archivo cargado:', this.file);            
        },
        functionalert() {
            if (this.buttontext == "cerrar") {
                this.snack = false;
            }
            if (this.buttontext == "aceptar") {
                this.buttontext == "cerrar";
                this.snack = false;
                this.timeoutsnak = 4000;
                let ruta = "/tareas";
                this.$router.push(ruta);
            }
        },
        descargarArchivo() {
            axios.get(`${process.env.VUE_APP_REST}/api/CargueExcel/GetEnlace/${this.idindicador}/${this.idavancecualitativotipovalornumber}`)
                .then((response) => {
                    if (response.data.codigoRespuesta === 'OK') {
                        const base64 = response.data.mensajeRespuesta;
                        const blob = this.base64ToBlob(base64);
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        //link.setAttribute('download', `${this.codigoIndicador}-${this.idtipovalor}-${this.rangoperiodo}.xlsx`); // Cambia 'archivo.xlsx' al nombre que quieras para el archivo
                        link.setAttribute('download', this.codigoIndicador + '-' + this.idtipovalor + '-' + this.rangoperiodo + '.xlsx'); // Cambia 'archivo.xlsx' al nombre que quieras para el archivo
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                });
        },
        base64ToBlob(base64) {
            const binaryString = window.atob(base64);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            return new Blob([bytes], { type: 'application/octet-stream' });
        },
        async uploadFileToServer(archivo) {
            const formData = new FormData();
            let bytes = window.crypto.getRandomValues(new Uint8Array(32));
            const randomBytes = () => (bytes = bytes.slice(1)) && bytes[0];
            let tran = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) => (c ^ (randomBytes() & (15 >> (c / 4)))).toString(16));
            formData.append('archivo', archivo);
            //alert(this.archivo.name);
            formData.append('nombre', archivo.name);
            formData.append('transaccion', tran);
            formData.append('idextension', "68EE451E-002A-448F-9AA9-06B01AD7D5F2");
            formData.append('idIndicador', this.idIndicadorNumber);
            formData.append('idTipoValor', this.idTipoValorNumber);
            formData.append('rangoPeriodo', this.rangoPeriodoString);
            formData.append('idavancecualitativo', this.idavancecualitativonumber);
            formData.append('idavancecualitativotipovalor', this.idavancecualitativotipovalornumber);
            formData.append('idPlantilla', '1')
            this.loading = true;
            axios.post(`${process.env.VUE_APP_REST}/api/cargueExcel/CargarExcel`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then((response) => {
                    this.loading = false;
                    console.log(response.data);
                    if (response.data.codigoRespuesta == "OK") {
                        this.MesaggeInfo.mensajeRespuesta = response.data.mensajeRespuesta;
                        this.MesaggeInfo.descripcionHtml = "OK";
                        this.MesaggeInfo.color = "infovue";
                        this.$emit('archivo-cargado',  this.idtipovalor);
                    }
                    else {                      
                        this.MesaggeInfo.mensajeRespuesta = response.data.mensajeRespuesta;
                        if (response.data.detalle.length > 0) {
                            this.MesaggeInfo.descripcionHtml = '<div style="width:100%"><br><b>' + response.data.detalle[0].codigoRespuesta + '</b></br>';
                        }
                        this.MesaggeInfo.descripcionHtml += '<ul>';
                        response.data.detalle.forEach((item) => {
                            this.MesaggeInfo.descripcionHtml += '<li>' + item.mensajeRespuesta + '</li>';
                        });
                        this.MesaggeInfo.descripcionHtml += '</ul>';
                        this.MesaggeInfo.descripcionHtml += '</div>';
                        this.MesaggeInfo.color = "errorvue";
                    }
                    this.snack = true;
                    //this.closedialog();
                    this.$refs.uploadFileRef.value = null;
                })
                .catch((error) => {
                    this.loading = false;
                    console.log(error);
                    this.$refs.uploadFileRef.value = null;
                });


        },
        handleFileImport() {
            this.isSelecting = true;
            // After obtaining the focus when closing the FilePicker, return the button state to normal
            window.addEventListener('focus', () => {
                this.isSelecting = false
            }, { once: true });
            // Trigger click on the FileInput
            //uploadFileCtl.click();
            this.$refs.uploadFileRef.click();
        },

        onFileChanged(e) {
            if (e.target.files.length > 0) { // Verifica si hay archivos seleccionados                
                this.uploadFileToServer(e.target.files[0]);
            }
        }

    }
}
</script>

<style scoped>
/* Your component styles go here */
</style>